import { useState } from "react";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import Input from "components/ui/Input";
import { useCompanyUsers, useCreateMessage } from "http-hooks/messages/useMessages";

export default function ComposeMessage({ onClose }) {
  const { data: users = [], isLoading: isLoadingUsers } = useCompanyUsers();
  const { mutateAsync: sendMessage, isPending: isSending } = useCreateMessage();

  const [selectedUser, setSelectedUser] = useState(null);
  const [subject, setSubject] = useState("");
  const [messageText, setMessageText] = useState("");

  const userOptions = users.map((u) => ({
    value: u.id,
    label: `${u.name} (${u.username})`,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUser || !subject.trim() || !messageText.trim()) return;
    try {
      await sendMessage({
        select_userid: selectedUser.value,
        message_subject: subject.trim(),
        message_text: messageText.trim(),
      });
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900">New Message</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <Select
          label="To"
          options={userOptions}
          value={selectedUser}
          onChange={setSelectedUser}
          placeholder={isLoadingUsers ? "Loading users..." : "Select recipient"}
          isRequired
        />

        <Input
          label="Subject"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Message subject"
          maxLength={200}
          isRequired
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Message *
          </label>
          <textarea
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            placeholder="Write your message..."
            rows={5}
            maxLength={500}
            required
            className="w-full resize-none rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
          <p className="mt-1 text-xs text-gray-400 text-right">{messageText.length}/500</p>
        </div>

        <div className="flex justify-end gap-3 pt-2 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSending || !selectedUser || !subject.trim() || !messageText.trim()}
            className="inline-flex items-center gap-2 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <PaperAirplaneIcon className="h-4 w-4" />
            {isSending ? "Sending..." : "Send Message"}
          </button>
        </div>
      </form>
    </>
  );
}
